import {
  ADD_MESSAGE,
  ADD_MESSAGES,
  BUTTON_CLICKED,
  BUTTON_POSTBACK,
  BUTTON_URL_OPEN,
  SCROLLTOBOTTOM,
  SCROLLTOFINISH,
  ON_FOCUS_FORM_CELL_INPUT,
  ON_BLUR_FORM_CELL_INPUT,
  ON_GET_SUGGESTED_QUESTIONS_SUCCESS,
  ADD_STREAM_MESSAGE,
  ADD_TEXT_LAST_MESSAGE,
  UPDATE_NEXT_CHUNK_INDEX,
  CLEAR_STREAM_MESSAGES,
  CANCEL_STREAMING,
} from '../../actions/chat-body/index';
import { compact } from 'lodash';

export const initialState = {
  messages: [],
  streamMessages: [],
  nextChunkIndex: 0,
  scrolling: false,
  isFormCellInputFocused: false,
  suggestedQuestions: [],
  ignoreMessagesBeforeSequenceId: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      if (action.message) {
        return addMessage(state, { ...action.message, auto_focus: !action.message.isBot });
      } else {
        return state;
      }
    case ADD_MESSAGES:
      return addMessages(state, action.messages);
    case ADD_TEXT_LAST_MESSAGE:
      return updateTextLastMessage(state, action.text);
    case ADD_STREAM_MESSAGE:
      return addStreamMessage(state, action.message);
    case CLEAR_STREAM_MESSAGES:
      return { ...state, streamMessages: [], nextChunkIndex: 0 };
    case UPDATE_NEXT_CHUNK_INDEX:
      return { ...state, nextChunkIndex: action.nextChunkIndex };
    case BUTTON_CLICKED:
    case BUTTON_POSTBACK:
    case BUTTON_URL_OPEN:
    case SCROLLTOBOTTOM:
      return scrollToBottom(state);
    case SCROLLTOFINISH:
      return scrollFinished(state);
    case ON_FOCUS_FORM_CELL_INPUT:
      return handleFormCellInput(state, true);
    case ON_BLUR_FORM_CELL_INPUT:
      return handleFormCellInput(state, false);
    case ON_GET_SUGGESTED_QUESTIONS_SUCCESS:
      return handleGetSuggestedQuestionsSuccess(state, action.payload);
    case CANCEL_STREAMING:
      return { ...state, streamMessages: [], nextChunkIndex: 0, ignoreMessagesBeforeSequenceId: action.inputSquenceId };
    default:
      return state;
  }
}

function addMessage(state, message) {
  return { ...state, messages: [...state.messages, message] };
}

function updateTextLastMessage(state, text) {
  return {
    ...state,
    messages: state.messages.map((message, index) => {
      if (index === state.messages.length - 1) {
        return { ...message, text: message.text + text };
      }
      return message;
    }),
  };
}

function addStreamMessage(state, message) {
  return { ...state, streamMessages: [...state.streamMessages, message] };
}

function addMessages(state, messages) {
  return { ...state, messages: state.messages.concat(compact(messages)) };
}

function scrollToBottom(state) {
  return { ...state, scrolling: true };
}

function scrollFinished(state) {
  return { ...state, scrolling: false };
}

function handleFormCellInput(state, isFocused) {
  return { ...state, isFormCellInputFocused: isFocused };
}

function handleGetSuggestedQuestionsSuccess(state, data) {
  return { ...state, suggestedQuestions: data };
}
